<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    :item-text="itemText"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
    >
    <template v-slot:item="item">
        <slot name="item" v-bind:item="item">
          <template v-if="!showDetails">
            <span>{{ item.item[itemText] }}</span>
          </template>
          <template v-else>
            <span><strong>{{ item.item.descricao }}</strong>
              &nbsp;<small>{{ labelDetalhes(item.item) }}</small></span>
          </template>
        </slot>
      </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import GruposService from '@/api/grupos-service';
import { buildNestedGroupLabels } from '@/utils/grupo-utils';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    onlyPai: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: 'descricao',
    },
    onlyFilho: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Categorias',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    labelDetalhes() {
      return item => (item.grupoPai ? `(${buildNestedGroupLabels(item.grupoPai)})` : '');
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    buildQuery(val) {
      let filter = `descricao like "%${val.toLowerCase()}%" or codigoInterno like "%${val.toLowerCase()}%"`;
      if (this.onlyPai) {
        filter += ' and grupoPai is null';
        return filter;
      }
      if (this.onlyFilho) {
        filter += ' and grupoPai is not null';
        return filter;
      }
      return filter;
    },
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      const searchValue = isSelected || !val ? '' : val;

      this.loading = true;
      GruposService.getList({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildQuery(searchValue),
      })
        .then((response) => {
          this.items = this.value ? [this.value, ...response.data.content] : response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch(null);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    this.debounceSearch();
  },
};
</script>
